@if (svgIcon() || fontIcon()) {
  <hx-icon [fontIcon]="fontIcon()" [inline]="true" [svgIcon]="svgIcon()" [style.font-size]="iconSize()" />
}

<ng-content />
